import{ALGOLIA_LEVEL_TEXT as s}from"../../consts/search-filters.js";const o=(o,r=s)=>`${r}${o}`;export{o as getAlgoliaHierarchyLevelText};
